import { base, facebookBaseUrl } from '../base';

export const baseODATA = 'gateway/mainodata';

export const facebookCampaign = `${base}/FacebookCampaign`;
export const facebookCampaignDispatch = `${base}/FacebookCampaignDispatchMessage`;

export const getFacebookAccount = `${facebookBaseUrl}/me?fields=id,name,accounts.limit(1000){ad_campaign,name,instagram_business_account{username,name}},adaccounts.limit(1000){name,account_id}`;
export const getFacebookODATA = `${baseODATA}/facebookcampaignsearchquery`;
